import { takeEvery, put, all, takeLatest, call } from 'redux-saga/effects';
import {
  getClientCoderDropdownService,
  getTransactionReportService
} from '../../../services/report/report.service';
import * as type from '../../ActionTypes';

function* fetchClientCoderDropdown(): any {
  try {
    const response = yield call(getClientCoderDropdownService);
    if (response.statusCode === 200) {
      yield put({
        type: type.GET_CLIENT_CODER_SUCCESS,
        payload: response?.data
      });
    } else {
      yield put({
        type: type.GET_CLIENT_CODER_FAILURE,
        error: response?.data || 'Oops, something went wrong!'
      });
    }
  } catch (error: any) {
    yield put({
      type: type.GET_CLIENT_CODER_FAILURE,
      error: error.message || 'Oops, something went wrong!'
    });
  }
}

function* fetchTransaction(action: any): any {
  try {
    const response = yield call(getTransactionReportService, action.params);
    if (response.statusCode === 200) {
      yield put({
        type: type.GET_TRANSACTION_REPORT_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: type.GET_TRANSACTION_REPORT_FAILURE,
        error: response?.data?.message
      });
    }
  } catch (error: any) {
    yield put({
      type: type.GET_TRANSACTION_REPORT_FAILURE,
      error: error?.message
    });
  }
}

function* reportSaga() {
  yield takeEvery(type.GET_CLIENT_CODER_REQUEST, fetchClientCoderDropdown);
  yield takeEvery(type.GET_TRANSACTION_REPORT_REQUEST, fetchTransaction);
}

export default reportSaga;
